import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const PendingCircle: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 16 16" color={props.fill} {...props}>
    <circle
      fill="transparent"
      cx="8"
      cy="8"
      r="7"
      strokeWidth="2"
      strokeDasharray="2 2"
      stroke="currentColor"
    />
  </BlueprintIcon>
);
